import { useQuery } from '@tanstack/react-query'

import type { ChatMedia } from '../@types'
import { fetchChatMedia } from '../api'

const useChatMedia = (chatId?: string, mediaId?: ChatMedia['id']) => {
  const queryKey = ['chatMedia', chatId, mediaId]
  return useQuery({
    queryKey: queryKey,
    queryFn: () => {
      if (!chatId || !mediaId) throw new Error('Invalid arguments')
      return fetchChatMedia(chatId, mediaId)
    },
    enabled: !!chatId && !!mediaId,
  })
}

export default useChatMedia
